var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-app',{attrs:{"id":"app"}},[_c('matan-header',{attrs:{"selectedHeader":_vm.selectedHeader,"header-options":_vm.headerOptions}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }